export interface CountryCode {
  name: string;
  code: string;
  isoCode: string;
}

export const countryCodes: CountryCode[] = [
  { name: 'Afghanistan (+93)', code: '93', isoCode: 'AF' },
  { name: 'Albania (+355)', code: '355', isoCode: 'AL' },
  { name: 'Algeria (+213)', code: '213', isoCode: 'DZ' },
  { name: 'American Samoa (+1684)', code: '1684', isoCode: 'AS' },
  { name: 'Andorra (+376)', code: '376', isoCode: 'AD' },
  { name: 'Angola (+244)', code: '244', isoCode: 'AO' },
  { name: 'Anguilla (+1264)', code: '1264', isoCode: 'AI' },
  { name: 'Antigua and Barbuda (+1268)', code: '1268', isoCode: 'AG' },
  { name: 'Argentina (+54)', code: '54', isoCode: 'AR' },
  { name: 'Armenia (+374)', code: '374', isoCode: 'AM' },
  { name: 'Aruba (+297)', code: '297', isoCode: 'AW' },
  { name: 'Australia (+61)', code: '61', isoCode: 'AU' },
  { name: 'Austria (+43)', code: '43', isoCode: 'AT' },
  { name: 'Azerbaijan (+994)', code: '994', isoCode: 'AZ' },
  { name: 'Bahamas (+1242)', code: '1242', isoCode: 'BS' },
  { name: 'Bahrain (+973)', code: '973', isoCode: 'BH' },
  { name: 'Bangladesh (+880)', code: '880', isoCode: 'BD' },
  { name: 'Barbados (+1246)', code: '1246', isoCode: 'BB' },
  { name: 'Belarus (+375)', code: '375', isoCode: 'BY' },
  { name: 'Belgium (+32)', code: '32', isoCode: 'BE' },
  { name: 'Belize (+501)', code: '501', isoCode: 'BZ' },
  { name: 'Benin (+229)', code: '229', isoCode: 'BJ' },
  { name: 'Bermuda (+1441)', code: '1441', isoCode: 'BM' },
  { name: 'Bhutan (+975)', code: '975', isoCode: 'BT' },
  { name: 'Bolivia (+591)', code: '591', isoCode: 'BO' },
  { name: 'Bosnia and Herzegovina (+387)', code: '387', isoCode: 'BA' },
  { name: 'Botswana (+267)', code: '267', isoCode: 'BW' },
  { name: 'Brazil (+55)', code: '55', isoCode: 'BR' },
  { name: 'British Indian Ocean Territory (+246)', code: '246', isoCode: 'IO' },
  { name: 'British Virgin Islands (+1284)', code: '1284', isoCode: 'VG' },
  { name: 'Brunei (+673)', code: '673', isoCode: 'BN' },
  { name: 'Bulgaria (+359)', code: '359', isoCode: 'BG' },
  { name: 'Burkina Faso (+226)', code: '226', isoCode: 'BF' },
  { name: 'Burundi (+257)', code: '257', isoCode: 'BI' },
  { name: 'Cambodia (+855)', code: '855', isoCode: 'KH' },
  { name: 'Cameroon (+237)', code: '237', isoCode: 'CM' },
  { name: 'Canada (+1)', code: '1', isoCode: 'CA' },
  { name: 'Cape Verde (+238)', code: '238', isoCode: 'CV' },
  { name: 'Cayman Islands (+1345)', code: '1345', isoCode: 'KY' },
  { name: 'Central African Republic (+236)', code: '236', isoCode: 'CF' },
  { name: 'Chad (+235)', code: '235', isoCode: 'TD' },
  { name: 'Chile (+56)', code: '56', isoCode: 'CL' },
  { name: 'China (+86)', code: '86', isoCode: 'CN' },
  { name: 'Christmas Island (+61)', code: '61', isoCode: 'CX' },
  { name: 'Cocos Islands (+61)', code: '61', isoCode: 'CC' },
  { name: 'Colombia (+57)', code: '57', isoCode: 'CO' },
  { name: 'Comoros (+269)', code: '269', isoCode: 'KM' },
  { name: 'Cook Islands (+682)', code: '682', isoCode: 'CK' },
  { name: 'Costa Rica (+506)', code: '506', isoCode: 'CR' },
  { name: 'Croatia (+385)', code: '385', isoCode: 'HR' },
  { name: 'Cuba (+53)', code: '53', isoCode: 'CU' },
  { name: 'Curacao (+599)', code: '599', isoCode: 'CW' },
  { name: 'Cyprus (+357)', code: '357', isoCode: 'CY' },
  { name: 'Czech Republic (+420)', code: '420', isoCode: 'CZ' },
  { name: 'Democratic Republic of the Congo (+243)', code: '243', isoCode: 'CD' },
  { name: 'Denmark (+45)', code: '45', isoCode: 'DK' },
  { name: 'Djibouti (+253)', code: '253', isoCode: 'DJ' },
  { name: 'Dominica (+1767)', code: '1767', isoCode: 'DM' },
  { name: 'Dominican Republic (+1809)', code: '1809', isoCode: 'DO' },
  { name: 'East Timor (+670)', code: '670', isoCode: 'TL' },
  { name: 'Ecuador (+593)', code: '593', isoCode: 'EC' },
  { name: 'Egypt (+20)', code: '20', isoCode: 'EG' },
  { name: 'El Salvador (+503)', code: '503', isoCode: 'SV' },
  { name: 'Equatorial Guinea (+240)', code: '240', isoCode: 'GQ' },
  { name: 'Eritrea (+291)', code: '291', isoCode: 'ER' },
  { name: 'Estonia (+372)', code: '372', isoCode: 'EE' },
  { name: 'Eswatini (+268)', code: '268', isoCode: 'SZ' },
  { name: 'Ethiopia (+251)', code: '251', isoCode: 'ET' },
  { name: 'Falkland Islands (+500)', code: '500', isoCode: 'FK' },
  { name: 'Faroe Islands (+298)', code: '298', isoCode: 'FO' },
  { name: 'Fiji (+679)', code: '679', isoCode: 'FJ' },
  { name: 'Finland (+358)', code: '358', isoCode: 'FI' },
  { name: 'France (+33)', code: '33', isoCode: 'FR' },
  { name: 'French Guiana (+594)', code: '594', isoCode: 'GF' },
  { name: 'French Polynesia (+689)', code: '689', isoCode: 'PF' },
  { name: 'Gabon (+241)', code: '241', isoCode: 'GA' },
  { name: 'Gambia (+220)', code: '220', isoCode: 'GM' },
  { name: 'Georgia (+995)', code: '995', isoCode: 'GE' },
  { name: 'Germany (+49)', code: '49', isoCode: 'DE' },
  { name: 'Ghana (+233)', code: '233', isoCode: 'GH' },
  { name: 'Gibraltar (+350)', code: '350', isoCode: 'GI' },
  { name: 'Greece (+30)', code: '30', isoCode: 'GR' },
  { name: 'Greenland (+299)', code: '299', isoCode: 'GL' },
  { name: 'Grenada (+1473)', code: '1473', isoCode: 'GD' },
  { name: 'Guadeloupe (+590)', code: '590', isoCode: 'GP' },
  { name: 'Guam (+1671)', code: '1671', isoCode: 'GU' },
  { name: 'Guatemala (+502)', code: '502', isoCode: 'GT' },
  { name: 'Guernsey (+44)', code: '44', isoCode: 'GG' },
  { name: 'Guinea (+224)', code: '224', isoCode: 'GN' },
  { name: 'Guinea-Bissau (+245)', code: '245', isoCode: 'GW' },
  { name: 'Guyana (+592)', code: '592', isoCode: 'GY' },
  { name: 'Haiti (+509)', code: '509', isoCode: 'HT' },
  { name: 'Honduras (+504)', code: '504', isoCode: 'HN' },
  { name: 'Hong Kong (+852)', code: '852', isoCode: 'HK' },
  { name: 'Hungary (+36)', code: '36', isoCode: 'HU' },
  { name: 'Iceland (+354)', code: '354', isoCode: 'IS' },
  { name: 'India (+91)', code: '91', isoCode: 'IN' },
  { name: 'Indonesia (+62)', code: '62', isoCode: 'ID' },
  { name: 'Iran (+98)', code: '98', isoCode: 'IR' },
  { name: 'Iraq (+964)', code: '964', isoCode: 'IQ' },
  { name: 'Ireland (+353)', code: '353', isoCode: 'IE' },
  { name: 'Isle of Man (+44)', code: '44', isoCode: 'IM' },
  { name: 'Israel (+972)', code: '972', isoCode: 'IL' },
  { name: 'Italy (+39)', code: '39', isoCode: 'IT' },
  { name: 'Ivory Coast (+225)', code: '225', isoCode: 'CI' },
  { name: 'Jamaica (+1876)', code: '1876', isoCode: 'JM' },
  { name: 'Japan (+81)', code: '81', isoCode: 'JP' },
  { name: 'Jersey (+44)', code: '44', isoCode: 'JE' },
  { name: 'Jordan (+962)', code: '962', isoCode: 'JO' },
  { name: 'Kazakhstan (+7)', code: '7', isoCode: 'KZ' },
  { name: 'Kenya (+254)', code: '254', isoCode: 'KE' },
  { name: 'Kiribati (+686)', code: '686', isoCode: 'KI' },
  { name: 'Kosovo (+383)', code: '383', isoCode: 'XK' }, // XK is a user-assigned code for Kosovo
  { name: 'Kuwait (+965)', code: '965', isoCode: 'KW' },
  { name: 'Kyrgyzstan (+996)', code: '996', isoCode: 'KG' },
  { name: 'Laos (+856)', code: '856', isoCode: 'LA' },
  { name: 'Latvia (+371)', code: '371', isoCode: 'LV' },
  { name: 'Lebanon (+961)', code: '961', isoCode: 'LB' },
  { name: 'Lesotho (+266)', code: '266', isoCode: 'LS' },
  { name: 'Liberia (+231)', code: '231', isoCode: 'LR' },
  { name: 'Libya (+218)', code: '218', isoCode: 'LY' },
  { name: 'Liechtenstein (+423)', code: '423', isoCode: 'LI' },
  { name: 'Lithuania (+370)', code: '370', isoCode: 'LT' },
  { name: 'Luxembourg (+352)', code: '352', isoCode: 'LU' },
  { name: 'Macau (+853)', code: '853', isoCode: 'MO' },
  { name: 'Madagascar (+261)', code: '261', isoCode: 'MG' },
  { name: 'Malawi (+265)', code: '265', isoCode: 'MW' },
  { name: 'Malaysia (+60)', code: '60', isoCode: 'MY' },
  { name: 'Maldives (+960)', code: '960', isoCode: 'MV' },
  { name: 'Mali (+223)', code: '223', isoCode: 'ML' },
  { name: 'Malta (+356)', code: '356', isoCode: 'MT' },
  { name: 'Marshall Islands (+692)', code: '692', isoCode: 'MH' },
  { name: 'Martinique (+596)', code: '596', isoCode: 'MQ' },
  { name: 'Mauritania (+222)', code: '222', isoCode: 'MR' },
  { name: 'Mauritius (+230)', code: '230', isoCode: 'MU' },
  { name: 'Mayotte (+262)', code: '262', isoCode: 'YT' },
  { name: 'Mexico (+52)', code: '52', isoCode: 'MX' },
  { name: 'Micronesia (+691)', code: '691', isoCode: 'FM' },
  { name: 'Moldova (+373)', code: '373', isoCode: 'MD' },
  { name: 'Monaco (+377)', code: '377', isoCode: 'MC' },
  { name: 'Mongolia (+976)', code: '976', isoCode: 'MN' },
  { name: 'Montenegro (+382)', code: '382', isoCode: 'ME' },
  { name: 'Montserrat (+1664)', code: '1664', isoCode: 'MS' },
  { name: 'Morocco (+212)', code: '212', isoCode: 'MA' },
  { name: 'Mozambique (+258)', code: '258', isoCode: 'MZ' },
  { name: 'Myanmar (Burma) (+95)', code: '95', isoCode: 'MM' },
  { name: 'Namibia (+264)', code: '264', isoCode: 'NA' },
  { name: 'Nauru (+674)', code: '674', isoCode: 'NR' },
  { name: 'Nepal (+977)', code: '977', isoCode: 'NP' },
  { name: 'Netherlands (+31)', code: '31', isoCode: 'NL' },
  { name: 'New Caledonia (+687)', code: '687', isoCode: 'NC' },
  { name: 'New Zealand (+64)', code: '64', isoCode: 'NZ' },
  { name: 'Nicaragua (+505)', code: '505', isoCode: 'NI' },
  { name: 'Niger (+227)', code: '227', isoCode: 'NE' },
  { name: 'Nigeria (+234)', code: '234', isoCode: 'NG' },
  { name: 'Niue (+683)', code: '683', isoCode: 'NU' },
  { name: 'Norfolk Island (+672)', code: '672', isoCode: 'NF' },
  { name: 'North Korea (+850)', code: '850', isoCode: 'KP' },
  { name: 'North Macedonia (+389)', code: '389', isoCode: 'MK' },
  { name: 'Northern Mariana Islands (+1670)', code: '1670', isoCode: 'MP' },
  { name: 'Norway (+47)', code: '47', isoCode: 'NO' },
  { name: 'Oman (+968)', code: '968', isoCode: 'OM' },
  { name: 'Pakistan (+92)', code: '92', isoCode: 'PK' },
  { name: 'Palau (+680)', code: '680', isoCode: 'PW' },
  { name: 'Palestine (+970)', code: '970', isoCode: 'PS' },
  { name: 'Panama (+507)', code: '507', isoCode: 'PA' },
  { name: 'Papua New Guinea (+675)', code: '675', isoCode: 'PG' },
  { name: 'Paraguay (+595)', code: '595', isoCode: 'PY' },
  { name: 'Peru (+51)', code: '51', isoCode: 'PE' },
  { name: 'Philippines (+63)', code: '63', isoCode: 'PH' },
  { name: 'Poland (+48)', code: '48', isoCode: 'PL' },
  { name: 'Portugal (+351)', code: '351', isoCode: 'PT' },
  { name: 'Puerto Rico (+1787)', code: '1787', isoCode: 'PR' },
  { name: 'Qatar (+974)', code: '974', isoCode: 'QA' },
  { name: 'Republic of the Congo (+242)', code: '242', isoCode: 'CG' },
  { name: 'Reunion (+262)', code: '262', isoCode: 'RE' },
  { name: 'Romania (+40)', code: '40', isoCode: 'RO' },
  { name: 'Russia (+7)', code: '7', isoCode: 'RU' },
  { name: 'Rwanda (+250)', code: '250', isoCode: 'RW' },
  { name: 'Saint Barthelemy (+590)', code: '590', isoCode: 'BL' },
  { name: 'Saint Helena (+290)', code: '290', isoCode: 'SH' },
  { name: 'Saint Kitts and Nevis (+1869)', code: '1869', isoCode: 'KN' },
  { name: 'Saint Lucia (+1758)', code: '1758', isoCode: 'LC' },
  { name: 'Saint Martin (+590)', code: '590', isoCode: 'MF' }, // French part
  { name: 'Saint Pierre and Miquelon (+508)', code: '508', isoCode: 'PM' },
  { name: 'Saint Vincent and the Grenadines (+1784)', code: '1784', isoCode: 'VC' },
  { name: 'Samoa (+685)', code: '685', isoCode: 'WS' },
  { name: 'San Marino (+378)', code: '378', isoCode: 'SM' },
  { name: 'Sao Tome and Principe (+239)', code: '239', isoCode: 'ST' },
  { name: 'Saudi Arabia (+966)', code: '966', isoCode: 'SA' },
  { name: 'Senegal (+221)', code: '221', isoCode: 'SN' },
  { name: 'Serbia (+381)', code: '381', isoCode: 'RS' },
  { name: 'Seychelles (+248)', code: '248', isoCode: 'SC' },
  { name: 'Sierra Leone (+232)', code: '232', isoCode: 'SL' },
  { name: 'Singapore (+65)', code: '65', isoCode: 'SG' },
  { name: 'Sint Maarten (+1721)', code: '1721', isoCode: 'SX' }, // Dutch part
  { name: 'Slovakia (+421)', code: '421', isoCode: 'SK' },
  { name: 'Slovenia (+386)', code: '386', isoCode: 'SI' },
  { name: 'Solomon Islands (+677)', code: '677', isoCode: 'SB' },
  { name: 'Somalia (+252)', code: '252', isoCode: 'SO' },
  { name: 'South Africa (+27)', code: '27', isoCode: 'ZA' },
  { name: 'South Korea (+82)', code: '82', isoCode: 'KR' },
  { name: 'South Sudan (+211)', code: '211', isoCode: 'SS' },
  { name: 'Spain (+34)', code: '34', isoCode: 'ES' },
  { name: 'Sri Lanka (+94)', code: '94', isoCode: 'LK' },
  { name: 'Sudan (+249)', code: '249', isoCode: 'SD' },
  { name: 'Suriname (+597)', code: '597', isoCode: 'SR' },
  { name: 'Svalbard and Jan Mayen (+47)', code: '47', isoCode: 'SJ' },
  { name: 'Sweden (+46)', code: '46', isoCode: 'SE' },
  { name: 'Switzerland (+41)', code: '41', isoCode: 'CH' },
  { name: 'Syria (+963)', code: '963', isoCode: 'SY' },
  { name: 'Taiwan (+886)', code: '886', isoCode: 'TW' },
  { name: 'Tajikistan (+992)', code: '992', isoCode: 'TJ' },
  { name: 'Tanzania (+255)', code: '255', isoCode: 'TZ' },
  { name: 'Thailand (+66)', code: '66', isoCode: 'TH' },
  { name: 'Togo (+228)', code: '228', isoCode: 'TG' },
  { name: 'Tokelau (+690)', code: '690', isoCode: 'TK' },
  { name: 'Tonga (+676)', code: '676', isoCode: 'TO' },
  { name: 'Trinidad and Tobago (+1868)', code: '1868', isoCode: 'TT' },
  { name: 'Tunisia (+216)', code: '216', isoCode: 'TN' },
  { name: 'Turkey (+90)', code: '90', isoCode: 'TR' },
  { name: 'Turkmenistan (+993)', code: '993', isoCode: 'TM' },
  { name: 'Turks and Caicos Islands (+1649)', code: '1649', isoCode: 'TC' },
  { name: 'Tuvalu (+688)', code: '688', isoCode: 'TV' },
  { name: 'U.S. Virgin Islands (+1340)', code: '1340', isoCode: 'VI' },
  { name: 'Uganda (+256)', code: '256', isoCode: 'UG' },
  { name: 'Ukraine (+380)', code: '380', isoCode: 'UA' },
  { name: 'United Arab Emirates (+971)', code: '971', isoCode: 'AE' },
  { name: 'United Kingdom (+44)', code: '44', isoCode: 'GB' },
  { name: 'United States (+1)', code: '1', isoCode: 'US' },
  { name: 'Uruguay (+598)', code: '598', isoCode: 'UY' },
  { name: 'Uzbekistan (+998)', code: '998', isoCode: 'UZ' },
  { name: 'Vanuatu (+678)', code: '678', isoCode: 'VU' },
  { name: 'Vatican City (+39)', code: '39', isoCode: 'VA' },
  { name: 'Venezuela (+58)', code: '58', isoCode: 'VE' },
  { name: 'Vietnam (+84)', code: '84', isoCode: 'VN' },
  { name: 'Wallis and Futuna (+681)', code: '681', isoCode: 'WF' },
  { name: 'Western Sahara (+212)', code: '212', isoCode: 'EH' },
  { name: 'Yemen (+967)', code: '967', isoCode: 'YE' },
  { name: 'Zambia (+260)', code: '260', isoCode: 'ZM' },
  { name: 'Zimbabwe (+263)', code: '263', isoCode: 'ZW' },
];
